import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { FiExtrato, MovimentaFidelidade } from '../models/movimenta-fidelidade';

@Injectable({
  providedIn: 'root'
})
export class FidelidadeMovimentaService {

  constructor(private http: HttpClient) {

  }

  consultar() {
    return this.http.get<MovimentaFidelidade[]>(globals.apiUrl + '/api/FiMovimenta/Lista');
  }

  consultarSaldo() {
    return this.http.get<number>(globals.apiUrl + '/api/FiMovimenta/gerarSaldo');
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);
    return this.http.get<any>(globals.apiUrl + '/api/FiMovimenta/ListaPag',
      {
        params: parametros
      });
  }

  consultarExtrato(cliente) {
    return this.http.get<FiExtrato>(globals.apiUrl + '/api/FiMovimenta/GerarExtrato',
      { params: new HttpParams().set('cliente', cliente) });
  }

  resgatar(cliente, produto) {
    return this.http.get<any>(globals.apiUrl + '/api/FiMovimenta/Resgatar',
      { params: new HttpParams().set('cliente', cliente).set('produto', produto) });
  }

}
